import PropTypes from 'prop-types'
import React, { Component, useContext, useState, createRef } from 'react'
import { BrowserRouter, Route, Link, useParams } from 'react-router-dom';
import { dbClicks } from '../firebase'
import { AppState } from '../context';
import emailPush from './EmailKeeper'
import Content from './Content'
import {Loader} from 'semantic-ui-react'

import {
  Ref,
  Rail,
  Sticky,
  Button,
  Container,
  Divider,
  Grid,
  Header,
  Icon,
  Image,
  List,
  Menu,
  Responsive,
  Segment,
  Sidebar,
  Visibility,
  Dimmer,
  Form
} from 'semantic-ui-react'
import EmailReader from './EmailKeeper';
import ModalBlogLogin from './ModalBlogLogin';

// const someContext = useContext(AppState);
//const [logged, setLogged] = useState(false);
// const {
//   clicks,
// } = someContext;

// Heads up!
// We using React Static to prerender our docs with server side rendering, this is a quite simple solution.
// For more advanced usage please check Responsive docs under the "Usage" section.
const getWidth = () => {
  const isSSR = typeof window === 'undefined'

  return isSSR ? Responsive.onlyTablet.minWidth : window.innerWidth
}
// function writeFirebase(){
//   var temp=clicks['getstarted']+1;
//   dbClicks.child('getstarted')
// }

/* eslint-disable react/no-multi-comp */
/* Heads up! HomepageHeading uses inline styling, however it's not the best practice. Use CSS or styled components for
 * such things.
 */
const HomepageHeading = ({ mobile }) => 
{
  const someContext = useContext(AppState);
  const {
    artid,
    articles,
    setArticles,
  } = someContext;
  console.log(articles)
return(
  <Container text>
    <Header
      as='h1'
      content={articles[artid] && artid ? articles[artid]['Title']: ""}
      inverted
      style={{
        fontSize: mobile ? '2em' : '4em',
        fontWeight: 'normal',
        marginBottom: 0,
        marginTop: mobile ? '1.5em' : '3em',
      }}
    />

  </Container>
)
    }

HomepageHeading.propTypes = {
  mobile: PropTypes.bool,
}

/* Heads up!
 * Neither Semantic UI nor Semantic UI React offer a responsive navbar, however, it can be implemented easily.
 * It can be more complicated, but you can create really flexible markup.
 */
class DesktopContainer extends Component {
  state = {}

  hideFixedMenu = () => this.setState({ fixed: false })
  showFixedMenu = () => this.setState({ fixed: true })

  render() {
    const { children } = this.props
    const { fixed } = this.state

    return (
      <Responsive getWidth={getWidth} minWidth={Responsive.onlyTablet.minWidth}>
        <Visibility
          once={false}
          onBottomPassed={this.showFixedMenu}
          onBottomPassedReverse={this.hideFixedMenu}
        >
          <Segment
            inverted
            textAlign='center'
            style={{ minHeight: 700, padding: '1em 0em' }}
            vertical
          >
            <Menu
              fixed={fixed ? 'top' : null}
              inverted={!fixed}
              pointing={!fixed}
              secondary={!fixed}
              size='large'
            >
              <Container>
                <Menu.Item href='/' fluid>
                  Home
                </Menu.Item>
                <Menu.Item href='/blog' fluid active>
                  Blog
                </Menu.Item>
                <Menu.Item href='/tutorial' fluid>
                  How It Works
                </Menu.Item>

                {/* <Menu.Item as='a'>Work</Menu.Item>
                <Menu.Item as='a'>Company</Menu.Item>
                <Menu.Item as='a'>Careers</Menu.Item> */}
                {/* <Menu.Item position='right'>
                  <Button as='a' inverted={!fixed}>
                    Log in primary family members
                  </Button>
                  <Button as='a' inverted={!fixed} primary={fixed} style={{ marginLeft: '0.5em' }}>
                    Log in secondary family members
                  </Button>
                  <Button as='a' inverted={!fixed} primary={fixed} style={{ marginLeft: '0.5em' }}>
                    Log in caregivers
                  </Button>
                </Menu.Item> */}
              </Container>
            </Menu>
            <HomepageHeading />
          </Segment>
        </Visibility>

        {children}
        <Segment style={{ padding: '4em 0em' }} vertical>
          <Grid container >
            <Grid.Row>
              <Grid.Column width={14}>
                <Header as='h3' style={{ fontSize: '2em' }}>
                  About us
          </Header>
                <p style={{ fontSize: '1.33em' }}>
                  We are a Northwestern based start-up radically innovating the way we care.
          </p>
                <Header as='h3' style={{ fontSize: '2em' }}>
                  Contact Us:
          </Header>
                <p style={{ fontSize: '1.33em' }}>
                  Reach out to us anytime at homecarenuvention@gmail.com and we will set up a time to chat to talk more about our product and our mission statement. You can also
                  call or send a text at (312)-934-9963. Or just enter your email here to be part of our mailing list:
          </p>
                {/* </Grid.Column> */}
              </Grid.Column>
            </Grid.Row>


            <Grid.Row>
              <Grid.Column textAlign='center'>
                <a href="//utkarshmishra2022.typeform.com/to/m7wknd" target="_blank"><Button size='huge'>Register</Button></a>
              </Grid.Column>
            </Grid.Row>

          </Grid>
        </Segment>
        <Segment inverted vertical style={{ padding: '5em 0em' }}>
          <Container>
            <Grid divided inverted stackable>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Header inverted as='h4' content='Follow us' />
                  <List link inverted>
                    <a href="//facebook.com/homecareapp" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Facebook</List.Item></a>
                    <a href="//twitter.com/Homecare_app" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Twitter</List.Item></a>
                    <a href="//instagram.com/homecare_nu" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Instagram</List.Item></a>
                    {/* <Hyperlink linkStyle={{ color: '#2980b9', fontSize: 20 }}
                <div style={{ fontSize: 15 }}>
                  Make clickable strings like https://github.com/obipawan/hyperlink stylable
  </div>
              </Hyperlink> */}

                    {/* <List.Item as='a'>Gazebo Plans</List.Item> */}
                  </List>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header inverted as='h4' content='Contact us' />
                  <List link inverted>
                    <List.Item>homecarenuvention@gmail.com</List.Item>
                    {/* <List.Item as='a'>How To Access</List.Item>
              <List.Item as='a'>Favorite X-Men</List.Item> */}
                  </List>
                </Grid.Column>
                <Grid.Column width={7}>
                  <Header as='h4' inverted>
                    Homecare
            </Header>
                  <p>
                    Help us help you care.
            </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Segment>
      </Responsive>
    )
  }
}

DesktopContainer.propTypes = {
  children: PropTypes.node,
}

class MobileContainer extends Component {
  state = {}

  handleSidebarHide = () => this.setState({ sidebarOpened: false })

  handleToggle = () => this.setState({ sidebarOpened: true })

  render() {
    const { children } = this.props
    const { sidebarOpened } = this.state

    return (
      <Responsive
        as={Sidebar.Pushable}
        getWidth={getWidth}
        maxWidth={Responsive.onlyMobile.maxWidth}
      >
        <Sidebar
          as={Menu}
          animation='push'
          inverted
          onHide={this.handleSidebarHide}
          vertical
          visible={sidebarOpened}
        >
          <Menu.Item href='/'>
            Home
          </Menu.Item>
          <Menu.Item href='/blog' active>
            Blog
          </Menu.Item>
          <Menu.Item href='/tutorial' fluid>
                  How It Works
          </Menu.Item>

          <Menu.Item as={Link} to={'/familymembers'}>Log in families</Menu.Item>

          <Menu.Item as={Link} to={'/caregivers'}>Log in caregiver</Menu.Item>
        </Sidebar>

        <Sidebar.Pusher dimmed={sidebarOpened}>
          <Segment
            inverted
            textAlign='center'
            style={{ minHeight: 350, padding: '1em 0em' }}
            vertical
          >
            <Container>
              <Menu inverted pointing secondary size='large'>
                <Menu.Item onClick={this.handleToggle}>
                  <Icon name='sidebar' />
                </Menu.Item>
              </Menu>
            </Container>
            <HomepageHeading mobile />
          </Segment>
          {children}
        </Sidebar.Pusher>
        <Divider />
        <Segment style={{ padding: '4em 0em', marginTop: "-20px" }} vertical>
          <Grid container >
            <Grid.Row>
              <Grid.Column width={14}>
                <Header as='h3' style={{ fontSize: '2em' }}>
                  About us
          </Header>
                <p style={{ fontSize: '1.33em' }}>
                  We are a Northwestern based start-up radically innovating the way we care.
          </p>
                <Header as='h3' style={{ fontSize: '2em' }}>
                  Contact Us:
          </Header>
                <p style={{ fontSize: '1.33em' }}>
                  Reach out to us anytime at homecarenuvention@gmail.com and we will set up a time to chat to talk more about our product and our mission statement. You can also
                  call or send a text at (312)-934-9963. Or just enter your email here to be part of our mailing list:
          </p>
                {/* </Grid.Column> */}
              </Grid.Column>
            </Grid.Row>
            <Grid.Row>
              <Grid.Column textAlign='center'>
                <a href="//utkarshmishra2022.typeform.com/to/m7wknd" target="_blank"><Button size='huge'>Register</Button></a>
              </Grid.Column>
            </Grid.Row>

          </Grid>
        </Segment>
        <Segment inverted vertical style={{ padding: '5em 0em' }}>
          <Container>
            <Grid divided inverted stackable>
              <Grid.Row>
                <Grid.Column width={3}>
                  <Header inverted as='h4' content='Follow us' />
                  <List link inverted>
                    <a href="//facebook.com/homecareapp" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Facebook</List.Item></a>
                    <a href="//twitter.com/Homecare_app" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Twitter</List.Item></a>
                    <a href="//instagram.com/homecare_nu" target="_blank"><List.Item style={{ marginBottom: "3px" }}>Instagram</List.Item></a>
                    {/* <Hyperlink linkStyle={{ color: '#2980b9', fontSize: 20 }}
                <div style={{ fontSize: 15 }}>
                  Make clickable strings like https://github.com/obipawan/hyperlink stylable
  </div>
              </Hyperlink> */}

                    {/* <List.Item as='a'>Gazebo Plans</List.Item> */}
                  </List>
                </Grid.Column>
                <Grid.Column width={3}>
                  <Header inverted as='h4' content='Contact us' />
                  <List link inverted>
                    <List.Item>homecarenuvention@gmail.com</List.Item>
                    {/* <List.Item as='a'>How To Access</List.Item>
              <List.Item as='a'>Favorite X-Men</List.Item> */}
                  </List>
                </Grid.Column>
                <Grid.Column width={7}>
                  <Header as='h4' inverted>
                    Homecare
            </Header>
                  <p>
                    Help us help you care.
            </p>
                </Grid.Column>
              </Grid.Row>
            </Grid>
          </Container>
        </Segment>
      </Responsive>
    )
  }
}

MobileContainer.propTypes = {
  children: PropTypes.node,
}

const ResponsiveContainer = ({ children }) => (
  <div>
    <DesktopContainer>{children}</DesktopContainer>
    <MobileContainer>{children}</MobileContainer>
  </div>
)

ResponsiveContainer.propTypes = {
  children: PropTypes.node,
}

const Eacharticle = () => {
  const [loader, setLoader] = useState(true);
  setTimeout(() => { setLoader(false) }, 2000)

  const someContext = useContext(AppState);
  const {
    artid,
    setArtid,
    articles,
    setArticles,
  } = someContext;

  const {articleID}=useParams();
  setArtid(articleID);
  return (!loader ? <ResponsiveContainer>
    <ModalBlogLogin />
    <Segment style={{ padding: '4em 0em' }} vertical>
      <Grid container style={{
        // maxWidth:"50px"
      }}>
        {/* <Grid.Row>
          <Grid.Column width={14}>
        <p as='h3' style={{ fontSize: '1.33em' }}>
          <b>May 22nd 2020, Karan Bhasin</b>, Co-Founder of <b>Homecare</b>, an app that streamlines communication for families of seniors. <a href="/" target="_blank"> <u>Learn more</u></a> or <a href="/signup" target="_blank"> <u>Sign Up</u></a>

        </p>
        <p style={{ fontSize: '1.33em' }}>
          During these times, the elderly population is not only most vulnerable to Coronavirus but also its effect on daily lifestyles. In metropolitan areas, even when the eventual stay-at-home order is indeed lifted, there will still be strict (and necessary) guidelines for seniors. Here’s information that you as a family member of the elderly can share with them or use to ensure they can get their food needs met during these times.
            </p>
            <p style={{ fontSize: '1.2em' }}>
          To receive similar content or build a community of senior care, a platform to share your story, Please leave your email below!          
            </p>
            
            <br />

          
        </Grid.Column>
        </Grid.Row> */}
        <Content id={articleID} />
      </Grid>
    </Segment>

  </ResponsiveContainer> :
      <Dimmer active>
        <Loader size='huge'>Loading</Loader>
      </Dimmer> )
}

export default Eacharticle;